<div class="well">
  <div class="container-fluid">
    <div class="jumbotron">
      <div style="text-align:center;">
        <h2 style="line-height: 2.0;">
          The Continuous Monitoring Program (CMP) application is currently unavailable due to Talent Architecture Modernization (TAM) R2 deployment.
        </h2>
        <h2 style="line-height: 2.0;">
          For any questions or further assistance, please contact&nbsp;
          <a href="mailto:USAssuranceContinuousMonitoringProgram@deloitte.com"
            title="Assurance Monitoring Team">US Assurance Continuous Monitoring Program</a>
        </h2>
      </div>
    </div>
  </div>
</div>
